import { Button, ButtonsGroup, Flex, Modal, Space, Text, useModal } from '@billy/design-system'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import {
  useUpdateOrganizationSettings,
  useUserOrganization,
  useUserOrganizationSettings,
} from '@modules-deprecated/app/organization'

import { SpotClients } from '../../../../assets/images'
import { ModalId } from '../../../../enums/modalId'
import { useOrganizationViewUrl } from '../../../../hooks/routing/useOrganizationViewUrl'
import { formatDate } from '../../../../utils'
import { useHasMigratedFolders } from '../../hooks/useHasMigratedFolders'
import { useIsClientDocumentsRoute } from '../../hooks/useIsClientDocumentsRoute'
import { getDocumentsRoutes } from '../../utils/getDocumentsRoutes'

const SETTING = 'documentsMigrationDoneModalViewedDate'

export const DocumentMigrationDoneModal = () => {
  const [displayModal, setDisplayModal] = useState(false)
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { organizationSettings } = useUserOrganizationSettings()
  const { update } = useUpdateOrganizationSettings()
  const { hasMigratedFolders } = useHasMigratedFolders()
  const navigate = useNavigate()
  const isClientDocumentsRoute = useIsClientDocumentsRoute()
  const documentsRoutes = getDocumentsRoutes(isClientDocumentsRoute)
  const { url: documentsUrl } = useOrganizationViewUrl(documentsRoutes.getMainRoute())

  const updateSetting = useCallback(() => {
    if (organization?.id) {
      update({ key: SETTING, organizationId: organization.id, value: formatDate(new Date()) as string })
    }
  }, [organization?.id, update])

  const { open, close } = useModal(ModalId.DocumentsMigrationDoneModal, {
    onClose: () => updateSetting(),
  })

  const handleClose = useCallback(() => {
    setDisplayModal(false)
    close()
  }, [close])

  const handleGoToDocuments = useCallback(() => {
    setDisplayModal(false)
    close()
    if (documentsUrl) {
      navigate(documentsUrl)
    }
  }, [close, documentsUrl, navigate])

  useEffect(() => {
    if (organizationSettings && !organizationSettings.documentsMigrationDoneModalViewedDate && hasMigratedFolders) {
      setDisplayModal(true)
      open()
    }
  }, [organizationSettings, hasMigratedFolders, open])

  if (!displayModal) {
    return null
  }

  return (
    <Modal id={ModalId.DocumentsMigrationDoneModal} size="s" closable={false}>
      <Modal.Body>
        <Flex flexDirection="column" alignItems="center">
          <SpotClients width={200} height={200} />
          <Space size="s24" />
          <Text variant="h3" weight="bold">
            {t('documents.modal.migration_done.availability.main_description')}
          </Text>
          <Space size="s16" />
          <Text variant="bodyMD">{t('documents.modal.migration_done.availability.description')}</Text>
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <ButtonsGroup>
          <Button onClick={handleClose} variant="tonal">
            {t('close')}
          </Button>
          <Button onClick={handleGoToDocuments}>{t('documents.modal.migration_done.availability.main_button')}</Button>
        </ButtonsGroup>
      </Modal.Footer>
    </Modal>
  )
}
